/**
 * Sidebar/SetupMenu/SetupFlyout/index.tsx
 * desc: the Setup section while the sidebar is collapsed — an icon row that opens the grouped links in a flyout
 *       beside the rail (the flyout itself is the shared Sidebar/Flyout)
 */

import { ComponentsIcon } from '../../../Icon/typed';
import Flyout from '../../Flyout';
import SetupGroups from '../SetupGroups';
import type { SetupSectionProps } from '../types';

const SetupFlyout = ({ groups, isActive, label }: SetupSectionProps) => (
    <div className="setup">
        <hr className="divider"/>

        <Flyout id="Setup" icon={ ComponentsIcon } isActive={ isActive } label={ label }>
            <SetupGroups groups={ groups }/>
        </Flyout>
    </div>
);

export default SetupFlyout;
